"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _checkTypes = _interopRequireDefault(require("check-types"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _OrderDetailsWidget = _interopRequireDefault(require("../../03_organisms/OrderDetailsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SinglePaneOrderSetupPage = function SinglePaneOrderSetupPage(props) {
  var sdk = props.sdk,
      selectedPassengers = props.selectedPassengers,
      numberOfPassengers = props.numberOfPassengers,
      _props$onBack = props.onBack,
      onBack = _props$onBack === void 0 ? function () {} : _props$onBack,
      history = props.history;
  var translatorForNamespace = sdk.i18n.translatorForNamespace;
  var t = translatorForNamespace('CheckoutPageUI');

  if (!_checkTypes["default"].nonEmptyArray(selectedPassengers) || selectedPassengers.length < numberOfPassengers) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
      to: "/book/passenger-details/"
    });
  }

  var goTo = function goTo(to) {
    return history.push("/book/".concat(to));
  };

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Your trip details'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_OrderDetailsWidget["default"], _extends({}, props, {
    onEditPassengers: function onEditPassengers() {
      return goTo('passenger-details');
    },
    onEditBillingDetails: function onEditBillingDetails() {
      return goTo('billing-details');
    },
    onEditCovidDetails: function onEditCovidDetails() {
      return goTo('covid-info');
    }
  })));
};

var _default = SinglePaneOrderSetupPage;
exports["default"] = _default;